<template>
  <page-content>
    <div slot="header">
      <h4 class="page-title-padding">基础数据导入</h4>
      <div style="display:flex;">
        <el-upload class="upload-demo" :action="actionUrl" :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" :on-exceed="handleExceed" :on-success='handleSuccess' :headers="Authorization" :on-error="uploadError" :show-file-list="false">
          <el-button size="mini" icon="el-icon-upload2" type="primary">{{importDate}}期-数据导入</el-button>
        </el-upload>
        &nbsp;&nbsp;<el-button type="primary" size="mini" icon="el-icon-download" @click="downloadEx">模板下载</el-button>
      </div>
    </div>
    <div slot="content">
      <template>
        <el-table v-loading="loading" :data='importBaseData' show-summary :summary-method="getSummaries" size="mini" max-height="780">
          <el-table-column v-for="(item,index) in importBaseHeadData" :key="'importBaseData_col' + index" :prop="item.value" :label="item.lable" header-align="center" align="center"></el-table-column>
        </el-table>
      </template>
    </div>
  </page-content>
</template>
<script>
import pageContent from '@/components/pageContent'
import storage from '@/assets/js/storage'
import { configUrl } from '@/assets/js/httpRequest/reqUrlConfig'
import { computeAssessDate } from '@/assets/js/date'
import { downloadExcel } from '@/assets/js/exportdata'
export default {
  data () {
    return {
      Authorization: '',
      actionUrl: '',
      importBaseData: [],
      importBaseHeadData: [],
      loading: false,
      importDate: '',
    }
  },
  created () {
    const user = storage.localGet('user');
    const token = user.token;
    this.Authorization = { Authorization: 'Bearer ' + token };
    this.actionUrl = configUrl.baseURL + '/import';
    this.importDate = computeAssessDate()[0]
    this.getBaseData(true)
  },
  components: {
    pageContent
  },
  methods: {
    getSummaries () { //页尾
      return [`共${this.importBaseData.length}条数据`]
    },
    handleRemove (file, fileList) {
      console.log(file, fileList);
    },
    handlePreview (file) {
      console.log(file);
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleSuccess (response, file, fileList) {
      this.getBaseData();
    },
    uploadError (err, file, fileList) {
      let errstr = err.toString().replace(/Error: /, '');
      let er = JSON.parse(errstr);;
      this.$message({ message: er.message, type: 'error' });
    },
    getBaseData (isShow) {
      const assessDate = computeAssessDate();
      let date = assessDate[0].split('/');
      let params = {
        start_date: date[0],
        end_date: date[1],
      };
      this.loading = true;
      this.$http.get('import/getBaseData', { params: params }).then((res) => {
        if (res.status === 200) {
          let labels = res.data[0].baseTitleName;
          let baseTitleName = []
          for (const key in labels) {
            baseTitleName.push(labels[key])
          }
          if (res.data[1].length > 0) {
            isShow != true && this.$message({ message: `表格共有${res.data[1].length}条数据`, type: 'success' })
            let tableHeadArr = [];
            for (let i = 0; i < baseTitleName.length; i++) {
              let existData = []
              res.data[1].forEach(item => {
                existData.push(...Object.keys(item))
                existData = Array.from(new Set(existData))
              });
              const value = existData.find(item => item === baseTitleName[i])
              tableHeadArr.push({
                value: value || existData[i] || baseTitleName[i],
                lable: value || baseTitleName[i]
              })
            }

            let nameObj = tableHeadArr.splice(13, 1);
            tableHeadArr.unshift(nameObj[0]);
            this.importBaseHeadData = tableHeadArr.filter(item => item.value || item.lable);
            this.importBaseData = res.data[1];
          }
        }
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
      })
    },
    // 下载模板
    downloadEx () {
      downloadExcel('get', location.origin + '/template.xlsx', null, '模板')
    }
  }
}
</script>
<style scoped>
</style>